import React from 'react';
import moment from 'moment';
import DaysListItem from './DayListItem';

const TournamentSummary = (props) => {
  const { shifts } = props;

  const canDeleteShift = () => {
    return shifts.length > 1;
  };

  const getDays = (shifts) => {
    const days = shifts.map(({ startDate }) => moment(startDate).format('YYYY-MM-DD'));

    return Array.from(new Set(days)).sort((a, b) => moment(a).diff(b));
  };

  const processShifts = (date) => {
    return shifts.filter(({ startDate }) => moment(startDate).format('YYYY-MM-DD') === date);
  };

  const days = getDays(shifts);

  return (
    <ul className="days-list">
      {days.map((date, idx) => {
        const dayShifts = processShifts(date);

        return (
          <DaysListItem
            {...props}
            canDeleteShift={canDeleteShift}
            key={`day-${idx}`}
            date={date}
            shifts={dayShifts}
            open={true}
            idx={idx}
            days={days}
          />
        );
      })}
    </ul>
  );
};

export default TournamentSummary;
